import { makeStyles } from "@material-ui/core"

export default makeStyles((theme) => ({
	root: {
		flexGrow: 1,
		maxWidth: 460,
		minWidth: 460,
	},
	form: {
		padding: "16px 13px",
		"& .MuiFormControl-root .MuiFormControl-root .MuiInputBase-root .MuiOutlinedInput-notchedOutline, .MuiFormControl-root .MuiInputBase-root .MuiOutlinedInput-notchedOutline":
			{
				borderColor: "inherit",
			},
	},
	formField: {
		"& .MuiOutlinedInput-notchedOutline": {
			borderColor: "inherit",
		},
		"& fieldset > legend": {
			float: "none",
		},
	},
	header: {
		display: "flex",
		alignItems: "center",
		justifyContent: "space-between",
		padding: "0 5px",
		//borderBottom: `1px solid ${theme.palette.grey[400]}`,
	},
	title: {
		color: theme.palette.text.primary,
		fontSize: 16,
		fontWeight: 500,
	},
	close: {
		paddingRight: 18,
	},
	divider: {
		margin: "0 -18px 0px",
		borderBottom: `1px solid ${theme.palette.grey[400]}`,
	},
	metadata: {
		paddingTop: 20,
		paddingBottom: 20,
	},
	subtitle: {
		paddingBottom: 10,
		fontSize: 14,
		fontWeight: 500,
	},
	marginTopBottom: {
		//marginTop: theme.spacing(2),
		marginBottom: theme.spacing(2),
	},
	marginBottom: {
		marginBottom: theme.spacing(2),
	},
	switchwrapper: {
		display: "flex",
		paddingRight: theme.spacing(2),
	},
	scroll: {
		maxHeight: "67vh",
		overflowY: "auto",
		overflowX: "hidden",
		padding: "0 5px",
		marginBottom: theme.spacing(4),
	},
	formWrapper: {
		maxWidth: 385,
	},
	footer: {
		display: "flex",
		justifyContent: "flex-end",
		padding: "12px 15px",
	},
	button: {
		marginLeft: theme.spacing(2),
		textTransform: "capitalize",
		fontSize: 16,
		fontWeight: 500,
	},
	select: {
		"& .MuiSvgIcon-root": {
			color: theme.palette.text.primary,
			fill: theme.palette.text.primary,
		},
		"& .MuiSelect-root": {
			...theme.typography.body1,
		},
		"& .MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline": {
			//border: "transparent",
		},
		"& .MuiSelect-icon.Mui-disabled": {
			opacity: "0.5",
		},
	},
	assigneeInfo: {
		fontWeight: 500,
		fontSize: 14,
		color: theme.palette.grey.D100,
		fontStyle: "italic",
	},
	textField: {
		"& .MuiOutlinedInput-input": {
			//padding: "12px 13px",
		},
	},
	goal: {
		"& textarea": {
			boxShadow: "none",
		},
		"& textarea:focus": {
			boxShadow: "none",
		},
	},
	text: {
		color: theme.palette.grey.D100,
		width: "95%",
		display: "block",
		overflow: "hidden",
		whiteSpace: "nowrap",
		textOverflow: "ellipsis",
	},
	infoIcons: {
		fontSize: 12,
		color: theme.palette.error.main,
		marginLeft: 5,
	},
	updateMsg: {
		fontStyle: "italic",
	},
	autoSelect: {
		"& .MuiSvgIcon-root": {
			color: theme.palette.text.primary,
			fill: theme.palette.text.primary,
		},
		"& .MuiSelect-icon.Mui-disabled": {
			opacity: "0.5",
		},
	},
	menuItemStyle: {
		borderBottom: `1px solid ${theme.palette.grey["P300"]}`,
	},
	assignMultiSelectErr: {
		color: theme.palette.error.main,
		marginTop: "2px",
	},
	autoAssignmentMargin: {
		marginBottom: theme.spacing(0),
	},
}))
